import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MaterialResource\GetMaterialResourceByIdController::__invoke
* @see app/Http/Controllers/MaterialResource/GetMaterialResourceByIdController.php
* @route '/api/material-resource/{material_resource}'
*/
const GetMaterialResourceByIdController = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMaterialResourceByIdController.url(args, options),
    method: 'get',
})

GetMaterialResourceByIdController.definition = {
    methods: ["get","head"],
    url: '/api/material-resource/{material_resource}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MaterialResource\GetMaterialResourceByIdController::__invoke
* @see app/Http/Controllers/MaterialResource/GetMaterialResourceByIdController.php
* @route '/api/material-resource/{material_resource}'
*/
GetMaterialResourceByIdController.url = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { material_resource: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { material_resource: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            material_resource: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        material_resource: typeof args.material_resource === 'object'
        ? args.material_resource.id
        : args.material_resource,
    }

    return GetMaterialResourceByIdController.definition.url
            .replace('{material_resource}', parsedArgs.material_resource.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MaterialResource\GetMaterialResourceByIdController::__invoke
* @see app/Http/Controllers/MaterialResource/GetMaterialResourceByIdController.php
* @route '/api/material-resource/{material_resource}'
*/
GetMaterialResourceByIdController.get = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMaterialResourceByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MaterialResource\GetMaterialResourceByIdController::__invoke
* @see app/Http/Controllers/MaterialResource/GetMaterialResourceByIdController.php
* @route '/api/material-resource/{material_resource}'
*/
GetMaterialResourceByIdController.head = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMaterialResourceByIdController.url(args, options),
    method: 'head',
})

export default GetMaterialResourceByIdController